import axios from 'axios';

const FILE_PATH = '/rest/v4/files';
const DEFAULT_CONFIG = { responseType: 'blob' };

export default {
  getStoredFile(id) {
    return axios.get(`${FILE_PATH}/${id}`, DEFAULT_CONFIG);
  },

  getTmpStoredFile(path) {
    return axios.get(`${FILE_PATH}/directPath`, { ...DEFAULT_CONFIG, params: { path } });
  },

  openFile(id) {
    return axios.get(`${FILE_PATH}/open/${id}`, DEFAULT_CONFIG);
  }
}
